var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuteMiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9H14.3C14.3 9.74 14.14 10.43 13.87 11.05L15.1 12.28C15.66 11.3 16 10.19 16 9ZM11.98 9.17C11.98 9.11 12 9.06 12 9V3C12 1.34 10.66 0 9 0C7.34 0 6 1.34 6 3V3.18L11.98 9.17ZM1.27 1L0 2.27L6.01 8.28V9C6.01 10.66 7.34 12 9 12C9.22 12 9.44 11.97 9.65 11.92L11.31 13.58C10.6 13.91 9.81 14.1 9 14.1C6.24 14.1 3.7 12 3.7 9H2C2 12.41 4.72 15.23 8 15.72V19H10V15.72C10.91 15.59 11.77 15.27 12.54 14.82L16.73 19L18 17.73L1.27 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteMiceIcon);
export default __webpack_public_path__ + "static/media/Mute-Mice-icon.768a950e0d8f44b7eaa7de754ee4d58c.svg";
export { ForwardRef as ReactComponent };